import { Navigate } from "react-router-dom";

const MerchantGuard = (props) => {
  const user = localStorage.getItem("rewardClubUser");
  const isLoggedIn = JSON.parse(user);
  return isLoggedIn?.id && isLoggedIn?.role === "merchant" ? props.children : <Navigate to="/" />
};

export default MerchantGuard;
